import { useTranslation } from 'react-i18next';
import { ChevronRight } from 'lucide-react';
import { Link } from '../../app/router';
import { cn, linkClass } from '../../ui';
import { Icon } from '../../ui/icons';

/** Where the page sits (P16-4): every level but the last is a link; the last is the current page. */
export function Breadcrumb({ items }: { items: readonly { label: string; to?: string }[] }) {
  const { t } = useTranslation();
  return (
    <nav aria-label={t('dashboard.breadcrumb')}>
      <ol className="flex flex-wrap items-center gap-1 font-sans text-sm text-fg-muted">
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1">
            {i > 0 && <Icon icon={ChevronRight} size={14} />}
            {item.to && i < items.length - 1 ? (
              // At least 44 × 44 px on touch (spec §13): a short word on a 20 px line is too small a target for a finger.
              <Link to={item.to} className={cn(linkClass, 'pointer-coarse:inline-flex pointer-coarse:min-h-11 pointer-coarse:min-w-11 pointer-coarse:items-center pointer-coarse:justify-center')}>
                {item.label}
              </Link>
            ) : (
              <span aria-current="page" className="text-fg">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
